import Common from "../../../Common";

export type CompanyPbxIsUsed = {[key: string]: CompanyPbxIsUsedItem[] }
export interface CompanyPbxIsUsedItem {
	id: id
	name: string
	description: string
	pbx_company_id: id
}

const IsUsed = class extends Common {
	read = (companyId: id, destinationId: id): CustomResponse<CompanyPbxIsUsed> =>
		this.get(`/company/${companyId}/pbx/isused/${destinationId}`)
}

export default IsUsed
